import type { IFlyerTabResources } from "@/src/flyers/FlyersTabResources.Resources";

export const FlyersTabResourcesEn: IFlyerTabResources = {
    locationTile: "Flyers suggestions for location:",
    mostPopularFlyers: {
        title: "Most popular promotional flyers",
    },

    brands: {
        title: "All promotional flyers",
        filtersTitle: "All",
        showMoreBtn: "Show More",
    },
};
